import { createAction, props } from '@ngrx/store';
import { ContactModel } from 'src/app/modules/shared/model/contactModel.model';

export const loadContactModels = createAction(
  '[ContactModel] Load ContactModels',
  props<{Contact: ContactModel}>()
);

export const loadContactModelsSuccess = createAction(
  '[ContactModel] Load ContactModels Success',
  props<{ data: any }>()
);

export const loadContactModelsFailure = createAction(
  '[ContactModel] Load ContactModels Failure',
  props<{ error: any }>()
);

export const addContactModels = createAction(
  '[ContactModel] Add ContactModels',
  props<{Contact: ContactModel}>()
);

export const addContactModelsSuccess = createAction(
  '[ContactModel] Add ContactModels Success',
  props<{ data: any }>()
);

export const addContactModelsFailure = createAction(
  '[ContactModel] Add ContactModels Failure',
  props<{ error: any }>()
);

export const removeContactModels = createAction(
  '[ContactModel] Remove ContactModels',
  props<{ Contact: ContactModel }>()
);

export const removeContactModelsSuccess = createAction(
  '[ContactModel] Remove ContactModels Success',
  props<{ data: any }>()
);

export const removeContactModelsFailure = createAction(
  '[ContactModel] Remove ContactModels Failure',
  props<{ error: any }>()
);
